import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { MenuItem, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';

// COMPONENT
import FilterSelect from '../../../../../component/select/filterSelect';
import InputTextField from '../../../../../component/input/inputTextField';
import { ButtonContained } from '../../../../../component/mui-custom/MuiCustom';
import { setLoading, unsetLoading } from '../../../../../store/slice/loading/loading.slice';
import { swalError, swalSuccess } from '../../../../../component/notification/swal';

// API
import { BudgetApi, createBudgetType } from '../../../../../api/budget/budget.api';


type Props = {
    fetchData: () => void;
    toggleModal: () => void;
    idBudget: number;
}

const EditBudget: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [budget, setBudget] = useState<createBudgetType>({
        budgetName: "",
        budgetNo: "",
        budgetOther: true,
        budgetStatus: t("STATUS.ACTIVE")
    })

    const handleGetBudgetDetail = async () => {
        dispatch(setLoading())
        await BudgetApi.getDetailBudget(props.idBudget)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    console.log(res.data?.result)
                    const { budgetName, budgetNo, budgetStatus, budgetOther } = res.data?.result
                    setBudget((prev) => ({
                        ...prev,
                        budgetName: budgetName,
                        budgetNo: budgetNo,
                        budgetStatus: budgetStatus,
                        budgetOther: budgetOther === 1 ? true : false
                    }))
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }
    const handleSubmit = async (event: React.FormEvent) => {
        dispatch(setLoading())
        event.preventDefault();
        await BudgetApi.updateBudget(props.idBudget, budget)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    swalSuccess(res.data?.description)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                swalError(error.response?.data?.description)
                console.log(error)
            })
            .finally(() => {
                props.fetchData()
                props.toggleModal()
            })
    }

    useEffect(() => {
        handleGetBudgetDetail()
    }, [])
    return (
        <form className='w-full' onSubmit={handleSubmit}>
            <div className='flex flex-col w-full mt-8 gap-5'>
                <span>
                    <InputTextField
                        required
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => setBudget((prev) => ({ ...prev, budgetNo: e.target.value }))}
                        value={budget.budgetNo}
                        heading='ลำดับแผนงาน'
                    />
                </span>
                <span>
                    <InputTextField
                        required
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => setBudget((prev) => ({ ...prev, budgetName: e.target.value }))}
                        value={budget.budgetName}
                        heading='ชื่อแผนงาน'
                    />
                </span>
                <span>
                    <FilterSelect
                        required
                        heading={t("สถานะ")}
                        renderValue={() => budget.budgetStatus === t("STATUS.ACTIVE") ?
                            <Typography className='text-light_success'> {t("STATUS.ACTIVE")}</Typography>
                            : <Typography className='text-danger'>{t('STATUS.INACTIVE')}</Typography>}
                        label={t('STATUS.LABEL')}
                        selectId="select-budget-status"
                        value={budget.budgetStatus}
                        labelId="label-budget-status"
                        onchange={(event: React.ChangeEvent<HTMLSelectElement>) => setBudget((prev) => ({ ...prev, budgetStatus: event.target.value }))}
                        options={[
                            <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                <Typography className='text-light_success'> {t("STATUS.ACTIVE")}</Typography>
                            </MenuItem>,
                            <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                <Typography className='text-danger'>{t('STATUS.INACTIVE')}</Typography>
                            </MenuItem>
                        ]}
                    />
                </span>
                {/* <span>
                    <FilterSelect
                        required
                        heading={t("สถานะเพิ่มเติมแหล่งที่มางบประมาน")}
                        renderValue={() => budget.budgetOther === true ?
                            <Typography className='text-light_success'> {t("STATUS.ACTIVE")}</Typography>
                            : <Typography className='text-danger'>{t('STATUS.INACTIVE')}</Typography>}
                        label={t('STATUS.LABEL')}
                        selectId="select-budget-status"
                        value={budget.budgetOther}
                        labelId="label-budget-status"
                        onchange={(event: React.ChangeEvent<HTMLSelectElement>) => setBudget((prev) => ({ ...prev, budgetOther: event.target.value === t("STATUS.ACTIVE") ? true : false }))}
                        options={[
                            <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                <Typography className='text-light_success'> {t("STATUS.ACTIVE")}</Typography>
                            </MenuItem>,
                            <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                <Typography className='text-danger'>{t('STATUS.INACTIVE')}</Typography>
                            </MenuItem>
                        ]}
                    />
                </span> */}
                <span className='mt-3 flex justify-center items-center'>
                    <ButtonContained
                        type='submit'
                        sx={{ maxWidth: 105 }}
                    >
                        {t("BUTTON.SUBMIT")}
                    </ButtonContained>
                </span>
            </div>
        </form>
    )
}

export default EditBudget